var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Route, Routes } from "react-router-dom";
import RMOrderbook from "./RM_Orderbook";
var RMOrderbookRouting = function (props) {
    return (React.createElement(Routes, null,
        React.createElement(Route, { index: true, element: React.createElement(RMOrderbook, __assign({}, props)) })));
};
export default RMOrderbookRouting;
